import { render, staticRenderFns } from "./ForgotLinks.vue?vue&type=template&id=c5cc61ec&"
import script from "./ForgotLinks.vue?vue&type=script&lang=ts&"
export * from "./ForgotLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports